import React,{useState,useEffect} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';
import Calculator from './components/Calculator';
import {HeroAbdomen} from './components/Didactics';
import ScoreGuides from './components/ScoreGuides';
import Education from './components/Education';
import MoreInfo from './components/MoreInfo';
import {scores} from './data/scores';
import './App.css';

import DoutoBanner from './DoutoBanner';
const {FiActivity,FiArrowRight,FiShield}=FiIcons;

function Header() {
  return <header className="site-header">
    <div className="container nav">
      <a href="#inicio" aria-label="Escore Alvarado, voltar ao início" className="brand logo"><svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><rect x="3" y="3" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="3"/><rect x="16" y="16" width="13" height="13" fill="var(--logo-accent)"/><line x1="16" y1="3" x2="16" y2="16" stroke="currentColor" strokeWidth="3"/><line x1="3" y1="16" x2="16" y2="16" stroke="currentColor" strokeWidth="3"/></svg><span>Escore de Alvarado</span></a>
      <nav className="desktop-nav" aria-label="Navegação principal"><a href="#calculadora">Calculadora</a><a href="#escores">Comparar escores</a><a href="#entenda">Entenda o tema</a><a href="#faq">Perguntas frequentes</a></nav>
      <a className="nav-cta" href="#calculadora">Calcular <SafeIcon icon={FiArrowRight} /></a>
    </div>
  </header>;
}

function Hero({selected,values,onSelect,onUpdate,onReset}) {
  const score=scores.find(item=>item.id===selected);
  return <section id="inicio" className="hero">
    <div className="container hero-layout">
      <div className="hero-copy">
        <p className="eyebrow">Uma ferramenta para entender os critérios clínicos</p>
        <h1>Escore de Alvarado: calculadora de apendicite</h1>
        <p className="hero-intro">Calcule e compare quatro escores usados na avaliação de suspeita de apendicite aguda. Veja os critérios, as faixas e as limitações em um só lugar.</p>
        <div className="hero-meta"><SafeIcon icon={FiShield} /><span>Material educativo. Não substitui avaliação médica.</span></div>
      </div>
      <Calculator selected={selected} values={values} onSelect={onSelect} onUpdate={onUpdate} onReset={onReset} />
      <HeroAbdomen score={score} values={values} />
    </div>
  </section>;
}

export default function App() {
  const [selected,setSelected]=useState('alvarado');
  const [values,setValues]=useState({});
  useEffect(()=>{
    const select=event=>setSelected(event.detail);
    const input=event=>setValues(previous=>({...previous,[event.detail.key]:event.detail.value}));
    const reset=()=>setValues({});
    window.addEventListener('score-select',select);
    window.addEventListener('score-input',input);
    window.addEventListener('score-reset',reset);
    return ()=>{window.removeEventListener('score-select',select);window.removeEventListener('score-input',input);window.removeEventListener('score-reset',reset);};
  },[]);
  const update=(key,value)=>setValues(previous=>({...previous,[key]:value}));
  const reset=()=>setValues({});
  const select=id=>setSelected(id);
  return <>
    <Header />
    <main><Hero selected={selected} values={values} onSelect={select} onUpdate={update} onReset={reset} /><DoutoBanner /><div className="container"><ScoreGuides /><Education /><MoreInfo /></div></main>
    <footer className="footer"><div className="container footer-inner"><a href="#inicio" className="brand logo"><svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><rect x="3" y="3" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="3"/><rect x="16" y="16" width="13" height="13" fill="var(--logo-accent)"/><line x1="16" y1="3" x2="16" y2="16" stroke="currentColor" strokeWidth="3"/><line x1="3" y1="16" x2="16" y2="16" stroke="currentColor" strokeWidth="3"/></svg><span>Escore de Alvarado</span></a><p>Informação clara para apoiar o entendimento dos escores clínicos.</p></div><div className="container footer-bottom">Ferramenta educativa. Não substitui avaliação médica nem exames de imagem.</div></footer>
  </>;
}
